import requester from '../requester';
import { GET_PAGE_INFO_URL } from '../../constants';

const Page = {
  getPageInfo: (id) => requester.get(GET_PAGE_INFO_URL(id)),
};

export default Page;